import { CommandItem } from "@focal/ui-kit";
import AvatarComponent from "@/components/common/AvatarCustom/AvatarCustom";
import { Tag } from "@focal/ui-kit";
import { motion } from "framer-motion";
import { Button } from "@focal/ui-kit";
import { useAnalytics } from "@/lib";
import { ImageBasedOnCrm } from "@/components/pages/Conversations/ConversationsDetails/TaskManagerModal/components/ImageBasedOnCrm";
import type { CrmType } from "@/types";

interface ConversationPersonTagSearchItemProps {
  name: string;
  email: string;
  type?: "client" | "user";
  crmType?: CrmType;
  handleSelectAuthor: () => void;
  onUnassign?: () => void;
  dataAttr?: string;
  dataText?: string;
}

export const ConversationPersonTagSearchItem = ({
  name,
  email,
  type,
  crmType,
  handleSelectAuthor,
  onUnassign,
  dataAttr,
  dataText,
}: ConversationPersonTagSearchItemProps) => {
  const { track } = useAnalytics();
  return (
    <CommandItem
      value={name + email}
      onSelect={() => {
        if (dataAttr) {
          track(dataAttr, dataText ? { event_text: dataText } : undefined);
        }
        handleSelectAuthor();
      }}
      asChild
    >
      <motion.div
        key={name + email}
        className="flex relative items-start rounded-md hover:bg-actions-selected cursor-pointer transition-colors"
        initial={{ opacity: 0.8 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6, type: "keyframes" }}
      >
        <div className="flex flex-1 min-w-0 overflow-hidden">
          <AvatarComponent name={name} className="mr-2 shrink-0" />
          <div className="flex flex-col min-w-0 flex-1 justify-center">
            <div className="flex items-center gap-1.5 min-w-0">
              <h4 className="text-primary font-medium text-sm truncate min-w-0">
                {name}
              </h4>
              {crmType && (
                <ImageBasedOnCrm
                  crmType={crmType}
                  className="shrink-0"
                />
              )}
            </div>
            <p className="text-primary/60 text-xs truncate">
              {email}
            </p>
          </div>
        </div>
        {onUnassign && (
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onUnassign();
            }}
            data-cy="unassign-button"
          >
            Un-assign
          </Button>
        )}
        {type && (
          <Tag variant="default" size="xs">
            {type === "client" ? "Client" : "Advisor"}
          </Tag>
        )}
      </motion.div>
    </CommandItem>
  );
};
